module.exports = __webpack_public_path__ + "img/role03.89cf71a0.png";